import { render, staticRenderFns } from "./AverageOrderValueCard.vue?vue&type=template&id=3519ec99"
import script from "./AverageOrderValueCard.vue?vue&type=script&lang=js"
export * from "./AverageOrderValueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports